import { atom } from 'jotai';
import { createUnwrappedPitchEventsAtom, getPitchMarkersEvents } from '@/utils/atoms/vis';
import { teamComparisonEventMarkersForMetricAtom } from '../queries/team/teamEventDataComparison';

export const teamComparisonPitchEventsAtom = atom(async get =>
  getPitchMarkersEvents(get, teamComparisonEventMarkersForMetricAtom),
);

export const teamComparisonUnwrappedPitchEventsAtom = createUnwrappedPitchEventsAtom(teamComparisonPitchEventsAtom);
